type DocumentShape = {
	readonly documentTypeId: number | null;
	readonly reevaluationEnabled: boolean;
};

type WorkflowShape = {
	readonly automaticSources: readonly { readonly documentTypeId: number }[];
};

/** A re-evaluation rewrites a document taken over from the file, so its type must be taken over by the group. */
function areReevaluationsSupported<T extends WorkflowShape>(
	value: readonly (readonly DocumentShape[])[],
	formData: T,
): boolean {
	const automaticTypeIds = formData.automaticSources.map((source) => source.documentTypeId);

	return value
		.flat()
		.every(
			(document) =>
				!document.reevaluationEnabled ||
				(document.documentTypeId !== null && automaticTypeIds.includes(document.documentTypeId)),
		);
}

export default areReevaluationsSupported;
